import { Actions, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, tap, take, filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';

import * as fromActions from '../actions/sport-active.actions';
import * as fromSelectors from '../selectors/sports.selectors';
import * as fromAuth from '../selectors/authentication.selectors';
import { StoreAction } from '../../models/rootState.model';
import { AUTH_ACTION_TYPES } from '../actions/authentication.actions';


@Injectable()
export class SportActiveEffects {

  constructor(
    private actions$: Actions,
    private store: Store<any>

  ) { }

  @Effect()
  init$: Observable<Action> = this.actions$.pipe(
    ofType(fromActions.CURRENT_SPORT_ACTIONS.INIT),
    switchMap(() => {
      // verify if there is an last state on storage
      const lastSport = localStorage.getItem('last_sport');
      if (lastSport) { return of(new fromActions.Action_Sport_InitSuccess(parseInt(lastSport))); }

      // get from logged user preferences
      return this.store.select(fromAuth.selectAuthUserPreferences).pipe(
        map(userPref => {

          if (userPref && userPref.sport_id) {
            return new fromActions.Action_Sport_InitSuccess(userPref.sport_id);
          }

          return new fromActions.Action_Sport_InitSuccessEmpty();
        })
      );

    })
  );

  @Effect()
  setById$: Observable<Action> = this.actions$.pipe(
    ofType(
      fromActions.CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT_ID,
      fromActions.CURRENT_SPORT_ACTIONS.INIT_SUCCESS
    ),
    switchMap((action: StoreAction<number>) => this.store.select(fromSelectors.selectSportsState).pipe(
      take(1),
      filter((state) => state.loaded),
      map(sports => {
        const id = action.payload;
        const sport = sports.sports.find(s => s.id == id);
        if (sport) {
          return new fromActions.Action_Sport_SetActiveByIdSuccess(sport);
        }
        return new fromActions.Action_Sport_SetActiveByIdFail(new Error('Esporte não localizado'));
      })
    ))
  );

  @Effect({ dispatch: false })
  saveOnStorage$: Observable<Action> = this.actions$.pipe(
    ofType(
      fromActions.CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT,
      fromActions.CURRENT_SPORT_ACTIONS.SET_ACTIVE_SPORT_ID_SUCCESS,
      fromActions.CURRENT_SPORT_ACTIONS.INIT_SUCCESS

    ),
    tap((action: StoreAction) => {
      if (action.payload) {
        let id = action.payload;
        if (action.payload.id) {
          id = action.payload.id;
        }
        if (id) {
          localStorage.setItem('last_sport', id);
        }
      }

    })
  );

  // resset on user signuot
  @Effect({ dispatch: false })
  onSignout$ = this.actions$.pipe(
    ofType(AUTH_ACTION_TYPES.SIGNOUT),
    tap(() => this.store.dispatch(new fromActions.Action_Sport_Resset()))
  );


}

